import { useState, useEffect } from "react";
import { fetchCapital } from "./api/capitalService";
import { COUNTRIES } from "./data/countries";
import "./styles/Body.css";
import "./styles/Header.css";
import "./styles/Scores.css";
import "./styles/Main.css";

function App() {
  // State management
  const [countRight, setCountRight] = useState(() => 
    JSON.parse(localStorage.getItem("countRight")) || 0
  );
  const [countWrong, setCountWrong] = useState(() => 
    JSON.parse(localStorage.getItem("countWrong")) || 0
  );
  const [capitalGuess, setCapitalGuess] = useState("");
  const [currentCountry, setCurrentCountry] = useState("Paraguay");
  const [capitalData, setCapitalData] = useState({
    normalized: "",
    display: "",
    previous: ""
  });
  const [answerStatus, setAnswerStatus] = useState({
    correct: false,
    wrong: false
  });

  // Persist scores to localStorage
  useEffect(() => {
    localStorage.setItem("countRight", JSON.stringify(countRight));
  }, [countRight]);

  useEffect(() => {
    localStorage.setItem("countWrong", JSON.stringify(countWrong));
  }, [countWrong]);

  // Fetch capital when country changes
  useEffect(() => {
    const loadCapital = async () => {
      try {
        const { normalized, display } = await fetchCapital(currentCountry);
        setCapitalData(prev => ({
          normalized,
          display,
          previous: prev.display
        }));
      } catch (error) {
        alert("Unable to fetch capital data. Please try again.");
      }
    };

    loadCapital();
  }, [currentCountry]);

  // Handlers
  const getRandomCountry = () => {
    return COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
  };

  const handleResetScores = () => {
    setCountRight(0);
    setCountWrong(0);
    setAnswerStatus({ correct: false, wrong: false });
  };

  const normalizeGuess = (guess) => {
    return guess
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,'/]/g, "")
      .replace(/[_-]/g, " ")
      .trim();
  };

  const handleSubmit = () => {
    if (capitalGuess.length < 2) {
      alert("Input must be at least two characters.");
      return;
    }

    const normalizedGuess = normalizeGuess(capitalGuess);
    const isCorrect = normalizedGuess === capitalData.normalized;

    if (isCorrect) {
      setCountRight(prev => prev + 1);
      setAnswerStatus({ correct: true, wrong: false });
    } else {
      setCountWrong(prev => prev + 1);
      setAnswerStatus({ correct: false, wrong: true });
    }

    setCapitalGuess("");
    setCurrentCountry(getRandomCountry());
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="App-container">
      <header className="App-title">
        <h1>GUESS THE CAPITAL</h1>
      </header>

      <div className="App-count-container">
        <div className="App-count">
          Right Guesses: {countRight}
          <p className={`App-count-right-answer${answerStatus.correct}`}>
            Yes, it is {capitalData.previous}
          </p>
        </div>

        <div className="App-count">
          Wrong Guesses: {countWrong}
          <p className={`App-count-wrong-answer${answerStatus.wrong}`}>
            No, it is {capitalData.previous}
          </p>
        </div>

        <div className="App-reset-container">
          <button className="App-button-reset" onClick={handleResetScores}>
            Reset Scores
          </button>
        </div>
      </div>

      <div className="App-main">
        <div className="App-main-guess">
          <div className="App-main-guess-question">
            <p className="App-main-guess-p">
              What is the capital of {currentCountry}?
            </p>
          </div>

          <div className="App-main-guess-input">
            <input
              type="text"
              autoComplete="off"
              placeholder="Guess the Capital..."
              value={capitalGuess}
              onChange={(e) => setCapitalGuess(e.target.value)}
              onKeyDown={handleKeyPress}
              className="App-guess-input"
            />
            <button className="App-guess-button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;